import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../Containers/Config/index';
import { GET_INVENTORY_QUOTA, GET_INVENTORY_QUOTA_SUCCESS, GET_INVENTORY_QUOTA_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getInventoryQuota({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/v2/admin/inventory-quota`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
        // pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_INVENTORY_QUOTA_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_INVENTORY_QUOTA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_INVENTORY_QUOTA_ERROR, payload: error });
  }
}

export function* watchGetInventorQuota() {
  yield takeEvery(GET_INVENTORY_QUOTA, getInventoryQuota);
}

function* getInventoryQuotaSaga() {
  yield all([fork(watchGetInventorQuota)]);
}

export default getInventoryQuotaSaga;
